import { TextFieldProps } from '@mui/material'
import type { FC } from 'react'
import { StyledTextField } from './textInput.styled'

const TextInput: FC<TextFieldProps> = (props): JSX.Element => {
    return <StyledTextField {...props} />
}

export default TextInput
